import { createSelector } from 'reselect'

import { selectLandingState } from './selectLandingState'

export const selectIsSearchMode = createSelector(
  [selectLandingState],
  ({ isSearchMode }) => isSearchMode
)
